<template>
  <div class="mock-record" v-if="info">

    <el-card v-loading="loading">
      <el-page-header :title="$t('返回')" slot="header" @back="goBack">
        <div slot="content" class="flex flex-between flex-v-center flex1">
          <div>
            <div class="flex flex-v-center">
              <h4 class="margin-r">
                <span style="margin-left: 10px;">{{ $t('答案') }}
                  & {{ $t('评分详情') }}</span>
              </h4>
            </div>
          </div>

          <div class="flex flex-v-center right">
            <el-button @click="evaluate()" icon="el-icon-thumb"
              v-if="$store.state.user && info.user_id == $store.state.user.id && info.status == 1" type="primary"
              round>{{ $t('申请打分') }}</el-button>
            <el-button disabled v-if="info.status == 2" type="primary" round>{{ $t('智能打分中') }}...</el-button>

            <el-button v-if="info.status == 3 && $store.state.user && info.user_id == $store.state.user.id" round plain
              class="margin-r" size="small" @click="share()" type="primary">
              <div class="flex flex-v-center"><i class="el-icon-share" style="font-size:18px;"></i>
                <h3>{{ $t('分享') }}</h3>
              </div>
            </el-button>


            <el-button round v-if="$store.state.user && info.user_id == $store.state.user.id" size="small" plain
              @click="remove()" type="primary">
              <div class="flex flex-v-center"><i class="el-icon-close" style="font-size:18px;"></i>
                <h3>{{ $t('删除') }}</h3>
              </div>
            </el-button>
          </div>
        </div>
      </el-page-header>

      <div class="margin-b flex flex-between flex-v-center" v-if="info.status == 3">
        <div>
          <h3>模考得分：{{ score }} / 90</h3>
          <div class="margin-ts st">
            {{ info.finished_at }}
          </div>
        </div>

        <div class="flex flex-v-center">
          <div class="margin-r">
            <i v-if="result == '通过'" style="font-size: 30px;color: green;" class="el-icon-success"></i>
            <i v-else style="font-size: 30px;color: gray;" class="el-icon-error"></i>
          </div>

          <div class="mt bold">
            {{ result }}
          </div>
        </div>
      </div>

      <el-divider></el-divider>

      <el-tabs v-model="selectedTab">
        <el-tab-pane v-for="(item, index) in info.items" :key="index"
          :label="item.source.title + ' (#' + item.source.no + ')'" :name="index.toString()">
          <div class="padding">
            <div v-for="(value, index) in item.result.segments" :key="value.segment_index" class="margin-b padding">
              <div class="bold flex flex-v-center flex-between">
                <span>Segment {{ Number(value.segment_index) + 1 }} </span>
                <el-tooltip :content="segments.includes(value.segment_index) ? $t('取消收藏') : $t('收藏片段')">
                            <i :style="{ color: segments.includes(value.segment_index) ? '#e6a13c' : '#666' }" @click="favoriteSegment(value.segment_index)"
                                class="el-icon-folder-add" style="font-weight: 900;font-size: 30px;"></i>
                        </el-tooltip>
              </div>
              <div class="margin-t flex flex-v-center"><span class="bold">{{ $t('我的录音') }}:</span><wave-player
                  v-if="JSON.parse(item.content)[index].url" class="margin-x"
                  :src="$host + JSON.parse(item.content)[index].url">
                </wave-player>
                <span v-else class="margin-l st">{{ $t('未录音') }}</span>
              </div>

              <div class="margin-t"><span class="bold">{{ $t('音频原文') }}:</span> {{
                item.source.words_en.split('\n')[value.segment_index]
              }}</div>
              <div class="margin-t"><span class="bold">{{ $t('参考翻译') }}:</span>&nbsp; {{
                value.reference_translation
              }}</div>
              <div class="margin-t" v-if="value.my_translation"><span class="bold">{{ $t('我的翻译') }}:</span> &nbsp;{{
                value.my_translation
                }}
              </div>
              <div class="margin-t" v-if="value.error_analysis"><span class="bold">{{ $t('错误分析') }}:</span>&nbsp; {{
                value.error_analysis
                }}
              </div>
            </div>
            <el-divider></el-divider>
            <template v-if="item.result.summary">
              <div class="bold margin-t">
                {{ $t('得分') }}： <span class="color-primary">{{ item.result.final_score }}</span> / 45
              </div>

              <div class="bold margin-t">
                {{ $t('总结') }}： {{ item.result.summary }}
              </div>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <share-dialog v-if="info.status == 3" ref="shareDialog"></share-dialog>
    <el-dialog top="20%" custom-class="br" :visible.sync="centerDialogVisible" :close-on-click-modal="false"
      :show-close="false" width="30%" center>
      <h4 slot="title"></h4>
      <div class="center st1">{{ $t("确认进行智能模考打分") }}?</div>
      <span slot="footer" class="dialog-footer center">
        <el-button size="small" @click="centerDialogVisible = false">{{ $t('取 消') }}</el-button>
        <el-button size="small" type="primary" @click="doEvaluate()">{{ $t('确 认') }}</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else>
    <el-page-header :title="$t('返回')" slot="header" @back="goBack"></el-page-header>
    <el-empty></el-empty>
  </div>

</template>

<script>

import shareDialog from '../../components/ShareDialog.vue';
import wavePlayer from '../../components/WavePlayer.vue';

export default {
  components: {
    shareDialog,
    wavePlayer
  },
  data() {
    return {
      score: 0,
      loading: false,
      source: null,
      centerDialogVisible: false,
      selectedTab: "0",
      info: null,
      segments: []
    };
  },

  computed: {
    result: function () {
      if (this.score >= 63 && this.info.items.filter(v => v.score >= 29).length == 2) return '通过'
      return '不通过'
    }
  },

  watch:{
    selectedTab: function (val) {
      if (this.info && this.info.items[val] && this.info.items[val].source) {
        this.source = this.info.items[val].source;
        this.get_segments();
      }
    } 
  },

  activated() {
    if (this.info && this.info.id != this.$route.query.id) {
      this.query()
    }
  },

  created() {
    this.query();
  },





  methods: {
    get_segments() {
      this.$http.post("/api/ccl/favorite/info", { source_id: this.source.id }).then((info) => {
        if (info && info.segments) {
          this.segments = info.segments;
        } else {
          this.segments = [];
        }
      })
    },
    share() {
      this.$refs.shareDialog.show("分享模考", window.location.href + "&uid=" + this.$store.state.user.id, "复制链接，分享本次模考成绩！");
    },
    remove() {
      this.$confirm(this.$t('是否删除本次模考记录?'), this.$t('提示'), {
        // center: true,
        confirmButtonText: this.$t('确定'),
        confirmButtonClass: "confirm-btn",
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(() => {
        this.$http.post("/api/mock/record/remove", { id: this.info.id }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('删除成功') + '!'
          });
        })
        this.goBack();
      }).catch(() => {

      });
    },

    goBack() {
      this.$router.back();
    },
    evaluate() {
      if (this.$store.getters.getRole() == 0) {
        this.$vip_alert("此功能");
      } else {
        this.centerDialogVisible = true;
      }
    },
    doEvaluate() {
      this.$http.post("/api/mock/record/evaluate", { id: this.info.id }).then((() => {
        this.info.status = 2
        this.centerDialogVisible = false;
        this.$message.success("提交成功")
      }))
    },

    favoriteSegment(segment) {
      this.$http.post("/api/ccl/favorite", {
        source_id: this.source.id,
        segment: segment,
      }).then((info) => {
        if (info && info.segments.includes(segment)) {
          this.$message({
            message: this.$t('片段已收藏'),
            type: 'success'
          });
          this.segments = info.segments;
        } else {
          this.$message({
            message: this.$t('片段已取消收藏'),
            type: 'info'
          });
          this.segments = [];
        }
      })
    },

    query() {
      this.loading = true
      let id = this.$route.query.id;
      let uid = this.$route.query.uid || 0;
      this.$http.post("/api/mock/record/info", { id: id, uid: uid }).then((info) => {
        this.info = info;
        this.score = Math.floor((this.info.items.reduce((sum, v) => sum + v.score, 0)))

        this.source = this.info.items[0].source;
        this.get_segments();
        this.loading = false
      })
    },

  }
}
</script>

<style scoped>
.word-mock.high-light {
  background-color: yellow;
}

.high-light1,
.word-mock.high-light1 {
  color: red;
}

.word-mock.high-light2 {
  color: green;
}

.mock-record>>>.el-tabs__item {
  line-height: 10px !important;
  font-size: 16px;
  color: #aaa;
}


.mock-record>>>.el-tabs__item.is-active {
  color: #e6a13c;
}

.mock-record>>>.el-card__header .el-page-header__content {
  width: 0;
  flex: 1;
}


.mock-record>>>.el-card__header .el-page-header__left {
  align-items: center;
}

.mock-record>>>.end {
  line-height: 30px;
}

.mock-record>>>.symbol {
  padding-left: 0;
  padding-right: 0;
}
</style>
